export enum PrescreenedOfferType {
    Online = 'Online',
    Branch = 'Branch',
    NoMatch = 'No Match',
}
